import { DiagnosisResultPersonalityType } from '@/gql/graphql';

// Deprecated: gqlのenumを使ってください
const PersonalityIds = [1, 2, 3, 4, 5, 6, 7, 8] as const;
export type PersonalityId = ValueOf<typeof PersonalityIds>;
export type DiagnosisPersonality = {
  id: PersonalityId;
  title: string;
  description: string;
};

export const isPersonalityId = (id: number): id is PersonalityId =>
  PersonalityIds.includes(id as PersonalityId);

export const convertPersonalityIdToDiagnosisResultPersonalityType = (
  id: Maybe<PersonalityId>
): Maybe<DiagnosisResultPersonalityType> => {
  switch (id) {
    case 1:
      return DiagnosisResultPersonalityType.A;
    case 2:
      return DiagnosisResultPersonalityType.B;
    case 3:
      return DiagnosisResultPersonalityType.C;
    case 4:
      return DiagnosisResultPersonalityType.D;
    case 5:
      return DiagnosisResultPersonalityType.E;
    case 6:
      return DiagnosisResultPersonalityType.F;
    case 7:
      return DiagnosisResultPersonalityType.G;
    case 8:
      return DiagnosisResultPersonalityType.H;
    default:
      return undefined;
  }
};
